import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useVehicles } from "../../Context/VehiclesContext";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import style from "../../assets/jss/disal-main/components/Modal";

const useStyles = makeStyles(style);

const ModalDelete = () => {
  const classes = useStyles();
  const { deleteItem, setDeleteItem, doDelete } = useVehicles();

  const handleClickAccept = async () => {
    await doDelete();
  };

  const handleClose = () => {
    setDeleteItem(null);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={!!deleteItem}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={!!deleteItem}>
        <div className={classes.paper} style={{ width: "500px" }}>
          <div className="modal-confirm">
            <h3>Confirmación</h3>
            <p>¿Estás seguro que quieres eliminar este vehículo?</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn-modal-salida"
              style={{ textDecoration: "underline", marginRight: "10px" }}
              onClick={handleClose}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn-modal-salida"
              style={{ textDecoration: "underline" }}
              onClick={handleClickAccept}
            >
              Confirmar
            </button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default ModalDelete;
